import { PERMISSIONS } from '@/generated/permissions'

export const customerRoutes = [
  {
    component: () =>
      import('@/domains/accounting/customers/pages/IndexPage.vue'),
    meta: {
      anyPerm: [
        PERMISSIONS.CUSTOMER_READ,
        PERMISSIONS.CUSTOMER_CREATE,
        PERMISSIONS.CUSTOMER_UPDATE,
      ],
      requiresAuth: true,
      requiresQuickBooks: true,
    },
    name: 'customers-index',
    path: '/customers',
  },
  {
    component: () => import('@/domains/accounting/customers/pages/NewPage.vue'),
    meta: {
      anyPerm: [PERMISSIONS.CUSTOMER_CREATE],
      requiresAuth: true,
      requiresQuickBooks: true,
    },
    name: 'customers-new',
    path: '/customers/new',
  },
  {
    component: () =>
      import('@/domains/accounting/customers/pages/DetailPage.vue'),
    meta: {
      anyPerm: [PERMISSIONS.CUSTOMER_UPDATE],
      requiresAuth: true,
      requiresQuickBooks: true,
    },
    name: 'customers-detail',
    path: '/customers/:id',
  },
]
